export default (urlParameters) => {
  return {
    ads_allowed: true,
    promo_modal_allowed: true
  }
}
